import React, { useContext, useEffect } from 'react';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import { AppRoutes } from '../enums/Approutes';
import { AuthContext } from './authContext';
import LoaderGif from '../assets/gifs/loader.gif'

const AuthLoader: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const publicRoutes = [
    AppRoutes.LOGIN,
    AppRoutes.LOGIN_WITH_REFERRAL,
    AppRoutes.RESET_PASSWORD,
    AppRoutes.SET_NEW_PASSWORD,
    AppRoutes.WELCOME,
    AppRoutes.ON_BOARDING,
    AppRoutes.PROFILE,
    AppRoutes.TERMS,
    AppRoutes.PRIVACY
  ];

  const isPublicRoute = publicRoutes.some((path) =>
    matchPath({ path, end: true }, location.pathname)
  );

  useEffect(() => {
    if (!isLoading && isAuthenticated === false && !isPublicRoute) {
      navigate(AppRoutes.LOGIN, { replace: true });
    }
  }, [isAuthenticated, isPublicRoute, isLoading, navigate]);

  if (isLoading || isAuthenticated === null) {
    return <div className='w-screen h-screen flex justify-center items-center'>
      <img src={LoaderGif} alt='' className='w-16 h-auto object-cover' />
    </div>;
  }

  return <>{children}</>;
};

export default AuthLoader;
